export default __webpack_public_path__ + "static/media/NoLists.09a2734f.svg";